<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row justify="center" dense v-if="inst_data!=''">
            <v-col cols="12" sm="3" md="3"><strong>Name :</strong> {{inst_data.name}}</v-col>
            <v-col cols="12" sm="3" md="3"><strong>Employee Designation : </strong> {{ inst_data.inst_designation }} </v-col>
            <v-col cols="12" sm="3" md="3"><strong>Employee Type :</strong> {{ inst_data.inst_employeetype }} </v-col>
            <v-col cols="12" sm="3" md="3"><strong>Date Of Joining :</strong> {{ inst_data.inst_date_of_joining }}</v-col>
        </v-row>
        <!-- {{authority_score_List}} -->
        <v-row dense v-if="authority_score_List!=''" v-for="(a,index) in authority_score_List" :key="index">
            <v-col cols="12" sm="3" md="3"> <strong> {{index+1}}. {{a.authority}}</strong> : {{a.authority_score}} Marks</v-col>
            <v-col cols="12" sm="3" md="3" v-if="a.authority!='Self'"> <strong>Remark</strong> : {{a.authority_remark}}</v-col>
        </v-row>
        <v-col cols="12" sm="12" md="12" v-if="measurement_list!=''">
            <v-simple-table fixed-header dense class="elevation-1" height="500px">
                <thead>
                    <tr>
                        <td class="">Sr. No.</td>
                        <td class="">Areas</td>
                        <td v-for="a in apprisal_level_list" :key="a.id">{{a.name}}</td>
                        <td v-for="a,index in authority_type_list" :key="index">{{a}} Score</td>
                        <!-- <th>Vice Principal/  Coordinator Score</th>
                            <th>Principal Score</th> -->
                        <!-- <th>Total Score</th> -->
                    </tr>
                </thead>
                <tbody v-for="(s, index) in measurement_list" :key="index">
                    <td><strong>{{s.parameter_no}}</strong></td>
                    <td :colspan="apprisal_level_list.length+4"><strong>{{s.parameter_name}}</strong> </td>
                    <tr v-for="(s1, index1) in s.all_sub_parameter_list" :key="index1">
                        <td>{{s1.asp_no}}</td>
                        <td>{{s1.asp_name}}</td>
                        <td v-for="aspl,index1 in s1.asp_linking_level" :key="index1">
                            <!-- {{aspl.as_al_description}}  -->
                            <span v-if="aspl.as_al_id">
                                <input v-if="aspl.as_al_id" class="mr-2 mt-2" type="checkbox" v-model="aspl.as_al_checked" @change="checkRadio(aspl.as_al_id,s1.asp_linking_level)" /><strong>Marks {{aspl.as_al_marks}}</strong>
                                <v-tooltip top content-class="custom-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon class="ml-5" v-bind="attrs" v-on="on" color="red">mdi-information</v-icon>
                                    </template>
                                    <span>
                                        {{aspl.as_al_description}}
                                    </span>
                                </v-tooltip>
                            </span>
                        </td>
                        <td v-for="aspm,index2 in s1.asp_marks" :key="index2">
                            <strong>{{aspm.marks}}</strong>
                        </td>
                        <!-- <td></td> -->
                        <!-- <td></td> -->
                    </tr>
                </tbody>
            </v-simple-table>
        </v-col>
        <v-row justify="center" v-if="authority_score_List!=''">
            <v-col cols="12" sm="6" md="6">
                <v-textarea outlined name="input-7-4" rounded dense v-model="remark" label="Enter Remark"></v-textarea>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-btn class="toolbar" :disabled="allowed_save == false" v-if="remark" outlined dense rounded @click="save()"> Save</v-btn>
        </v-row>
        <v-row justify="center" dense v-if="!this.allowed_save">
            <p style="color:red"> Appraisal Marks Are Already Approved...</p>
        </v-row>
    </v-container>
</div>
<!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    //  props: {
    //     inst: String,
    //     ay: String
    // },
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        radios: null,
        criteria: "",
        ay_list: [],
        ay: "",
        inst_list: [],
        inst: null,
        authority: null,
        measurement_list: [],
        inst_data: [],
        apprisal_level_list: [],
        checked_list: [],
        final_id: [],
        remark: null,
        authority_type_list: [],
        authority_score_List: []
    }),
    methods: {
        checkRadio(as_al_id, asp_linking_level) {
            for (let i = 0; i < asp_linking_level.length; i++) {
                if (asp_linking_level[i].as_al_id != as_al_id) {
                    asp_linking_level[i].as_al_checked = false;
                } else {
                    // alert(asp_linking_level[i].as_al_checked)
                    if (asp_linking_level[i].as_al_checked != true) {
                        asp_linking_level[i].as_al_checked = false;
                    } else {
                        this.checked_list.push(asp_linking_level[i])
                        asp_linking_level[i].as_al_checked = true;
                    }
                }
            }
        },
        save() {
            // console.log(this.checked_list)
            this.final_id = []
            for (let i = 0; i < this.checked_list.length; i++) {
                if (this.checked_list[i].as_al_checked == true) {
                    // alert("in if")
                    this.final_id.push(this.checked_list[i].as_al_id)
                }
            }
            //  console.log("1111"+this.final_id)
            //    if(this.final_id.length<=0){
            //         this.showSnackbar("#b71c1c", "Please select atleast one parameter!!!");
            //         return
            //    }
            const data = {
                remark: this.remark,
                final_id: this.final_id,
                ay: localStorage.getItem("setay"),
                inst: localStorage.getItem("setinst"),
                authority: localStorage.getItem("authority")
            }
            axios
                .post("SelfAppraisal/saveSelfAppraisalAuthorityMarks", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Saved Successfully...");
                        this.getReport();
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getReport() {
            const data = {
                ay: localStorage.getItem("setay"),
                inst: localStorage.getItem("setinst"),
                authority: localStorage.getItem("authority")
            }
            axios
                .post("SelfAppraisal/getTeacherApprisalPerformanceMeasurementReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.measurement_list = res.data.measurement_list
                        this.inst_data = res.data.inst_data
                        this.apprisal_level_list = res.data.apprisal_level_list
                        this.authority_type_list = res.data.authority_type_list
                        this.allowed_save = res.data.allowed_save
                        this.overlay = false;
                        this.remark = res.data.authority_remark
                        this.authority_score_List = res.data.authority_score_List
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.getReport();
    },
    watch: {},
};
</script>

<style scoped>
/* .v-text-field{
      width: 80px;
} */
.custom-tooltip {
    background-color: #222 !important;
    /* Dark background */
    color: #fff !important;
    /* White text */
    font-size: 14px;
    /* Adjust text size */
    border-radius: 6px;
    /* Rounded corners */
    padding: 8px 12px;
    /* Padding inside tooltip */
}

thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

tr,
td,
th {
    border: 1px solid black;
    /* text-align: center; */
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
    font-size: small;
}

td {
    font-size: small;
}

.weaklyoff {
    background: white !important;
}

.weaklyoff2 {
    background: yellow !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    /* text-align: center; */
    font-size: small;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
